// Status configuration with colors
export const STATUS_OPTIONS = [
  { value: 'New', label: 'New', color: '#94A3B8', bgColor: '#F1F5F9' },
  { value: 'Active', label: 'Active', color: '#3B82F6', bgColor: '#DBEAFE' },
  { value: 'In Production', label: 'In Production', color: '#8B5CF6', bgColor: '#EDE9FE' }, // Legacy status
  { value: 'On Hold', label: 'On Hold', color: '#F59E0B', bgColor: '#FEF3C7' },
  { value: 'Completed', label: 'Completed', color: '#10B981', bgColor: '#D1FAE5' },
  { value: 'Launched', label: 'Launched', color: '#10B981', bgColor: '#D1FAE5' }, // Legacy status
  { value: 'Archived', label: 'Archived', color: '#64748B', bgColor: '#E2E8F0' }
];

// Helper to get status config (with fallback for unknown statuses)
export const getStatusConfig = (status) => {
  // Try exact match first
  let config = STATUS_OPTIONS.find(s => s.value === status);
  
  // If no match, return a default config with the original status as label
  if (!config) {
    config = {
      value: status,
      label: status || 'Unknown',
      color: '#94A3B8',
      bgColor: '#F1F5F9'
    };
  }
  
  return config;
};

// Helper to check if status is archived
export const isArchived = (status) => {
  return status === 'Archived';
};
